<template>
  <SelectFilter
    title="Врачи"
    :items="items"
    :clearble="clearble"
    customContent
    :searchable="{ placeholder: 'ФИО врача' }"
    v-model="syncSelected"
    @reset-filter="(v) => this.$emit('reset-filter', v)"
    @submit="(v) => this.$emit('submit', v)"
  >
    <template v-slot="{ item }">
      <div class="card-doctor">
        <div
          v-if="item.icon"
          class="card-doctor__photo"
          :style="{
            backgroundImage: `url('${item.icon}')`
          }"
        ></div>
        <AvatarIcon v-else class="card-doctor__photo--undefined" />
        <div class="card-doctor__content">
          <span>{{ item.name }}</span>
          <span v-if="item.totalExperience"
            >Cтаж {{ item.totalExperience }} лет</span
          >
        </div>
      </div>
    </template>
  </SelectFilter>
</template>
<script>
import SelectFilter from '../selectFilter'
import AvatarIcon from '@/assets/icons/avatar'

export default {
  name: 'select-filter',
  components: {
    AvatarIcon,
    SelectFilter
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    value: {
      type: Array
    },
    clearble: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    syncSelected: {
      get() {
        return this.value ?? []
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  setup() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
@import 'style';
</style>
